import 'whatwg-fetch';
import {queryString} from 'utilities/url';
import railsData from '../utilities/rails-data';
import {handleFetchErrors} from '../utilities/fetch';
import jsonp from './jsonp';

const SHOPIFY_APP_HOST = railsData('shopify_app.host');

export const BASE_URI = '/services/validation';
export const SHOP_NAME_AVAILABILITY_URL = `https://${SHOPIFY_APP_HOST}/services/signup/check_availability.json`;
export const APP_URL_VALIDATION_ENDPOINT = 'app_url_validation';
export const PREFERENCES_URL_VALIDATION_ENDPOINT = 'app_url_validation';

const ValidationService = {
  checkInputValue(query, key) {
    const URL = `${BASE_URI}/${key}?value=${encodeURIComponent(query)}`;

    return fetch(URL, {credentials: 'same-origin'})
      .then(handleFetchErrors)
      .then(response => response.json());
  },

  checkShopAvailabilityFromName(shopName = '') {
    const URL = SHOP_NAME_AVAILABILITY_URL;
    const options = {
      params: {
        shop_name: shopName, // eslint-disable-line camelcase
      },
    };

    return jsonp(URL, options);
  },

  shopNameAvailability(shopName = '', baseLabel, validState = 'available') {
    const URL = SHOP_NAME_AVAILABILITY_URL;
    const options = {
      params: {
        shop_name: shopName // eslint-disable-line camelcase
          .replace('.myshopify.com', '')
          .replace('https://', '')
          .replace('http://', ''),
      },
    };

    if (shopName.trim() === '') {
      return Promise.resolve({
        success: false,
        message: `${baseLabel} cannot be empty`,
      });
    } else {
      return jsonp(URL, options).then((response = {}) => {
        const status = response.status === validState;
        const errorMsg =
          validState === 'available' ? 'is already taken' : 'does not exist';

        return {
          success: status,
          message: status ? '' : `${baseLabel} ${errorMsg}`,
        };
      });
    }
  },

  validateURL({query, validatorType, labelMessage}) {
    const queryParams = queryString.stringify({value: query});
    const URL = `${BASE_URI}/${validatorType}?${queryParams}`;

    return fetch(URL, {credentials: 'same-origin'})
      .then(handleFetchErrors)
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          return result;
        }
        result.message = `${labelMessage} ${result.message}`;

        return result;
      });
  },
};

export default ValidationService;
